import { action, makeObservable, observable } from 'mobx';

export class StudentCourseDrivenExperienceManager {
  constructor() {
    makeObservable(this);
  }

  @observable allowStudentCourseDrivenExperience = false;

  @observable allowStudentCourseDrivenAssignmentFiltering = true;

  @observable allowStudentCourseDrivenCarousel = true;

  @observable loadingStudentCourseDrivenExperience = false;

  @observable loadingStudentCourseDrivenAssignmentAction = false;

  @observable selectedCourseDrivenCarouselIndex = 0;

  @observable selectedCourseDrivenAssignmentMenuStatus = 'current';

  @action clearAll = () => {
    this.loadingStudentCourseDrivenExperience = false;
    this.loadingStudentCourseDrivenAssignmentAction = false;
    this.selectedCourseDrivenCarouselIndex = 0;
    this.selectedCourseDrivenAssignmentMenuStatus = 'current';
  }

  @action setAllowStudentCourseDrivenExperience = (toggle) => {
    this.allowStudentCourseDrivenExperience = toggle;
  }

  @action setAllowStudentCourseDrivenAssignmentFiltering = (toggle) => {
    this.allowStudentCourseDrivenAssignmentFiltering = toggle;
  }

  @action setAllowStudentCourseDrivenCarousel = (toggle) => {
    this.allowStudentCourseDrivenCarousel = toggle;
  }

  @action setLoadingStudentCourseDrivenExperience = (toggle) => {
    this.loadingStudentCourseDrivenExperience = toggle;
  }

  @action setLoadingStudentCourseDrivenAssignmentAction = (toggle) => {
    this.loadingStudentCourseDrivenAssignmentAction = toggle;
  }

  @action setSelectedCourseDrivenCarouselIndex = (index) => {
    this.selectedCourseDrivenCarouselIndex = index;
  }

  @action setSelectedCourseDrivenAssignmentMenuStatus = (status) => {
    this.selectedCourseDrivenAssignmentMenuStatus = status;
  }
}

export default new StudentCourseDrivenExperienceManager();
